//do not remove this constants
const constants = {};
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
  PATCH: "patch",
};

const CONTRACT_TERMS = [
  {
    title: "12 Months",
    value: 12,
  },
  {
    title: "18 Months",
    value: 18,
  },
  {
    title: "24 Months",
    value: 24,
  },
  {
    title: "36 Months",
    value: 36,
  },
  {
    title: "48 Months",
    value: 48,
  },
];

/** Lead/prospect contract length options (single source of truth). */
const   CONTRACT_LENGTHS = [
  {
    title: "12 Months",
    isSelected: false,
    value: 12,
    pricingMode: "sale",
    availableForNew: false,
  },
  {
    title: "18 Months",
    isSelected: false,
    value: 18,
    pricingMode: "sale",
    availableForNew: false,
  },
  {
    title: "24 Months",
    isSelected: false,
    value: 24,
    pricingMode: "sale",
    availableForNew: true,
  },
  {
    title: "36 Months",
    isSelected: false,
    value: 36,
    pricingMode: "sale",
    availableForNew: true,
  },
  {
    title: "12 Months - Saver",
    isSelected: false,
    value: 12,
    pricingMode: "buy",
    availableForNew: true,
  },
];

/** Fresh copy for state/reset so selections don't mutate the shared constant. */
const getDefaultContractLengths = () =>
  CONTRACT_LENGTHS.map((item) => ({ ...item }));

const POSITION = [
  { title: "Director", value: "director" },
  { title: "Partner", value: "partner" },
  { title: "Company Secretary", value: "company_secretary" },
  { title: "Sole Trader", value: "sole_trader" },
  { title: "Owner", value: "owner_director" },
];

const COUNTIES = [
  {
    title: "Bedfordshire",
    value: "bedfordshire",
  },
  {
    title: "Berkshire",
    value: "berkshire",
  },
  {
    title: "Bristol",
    value: "bristol",
  },

  {
    title: "Buckinghamshire",
    value: "buckinghamshire",
  },

  {
    title: "Cambridgeshire",
    value: "cambridgeshire",
  },

  {
    title: "Cheshire",
    value: "cheshire",
  },

  {
    title: "Cornwall",
    value: "cornwall",
  },

  {
    title: "Cumbria",
    value: "cumbria",
  },

  {
    title: "Derbyshire",
    value: "derbyshire",
  },

  {
    title: "Devon",
    value: "devon",
  },

  {
    title: "Dorset",
    value: "dorset",
  },

  {
    title: "Durham",
    value: "durham",
  },

  {
    title: "East Sussex",
    value: "east_sussex",
  },

  {
    title: "Essex",
    value: "essex",
  },

  {
    title: "Gloucestershire",
    value: "gloucestershire",
  },

  {
    title: "Greater London",
    value: "greater_london",
  },

  {
    title: "Greater Manchester",
    value: "greater_manchester",
  },

  {
    title: "Hampshire",
    value: "hampshire",
  },

  {
    title: "Herefordshire",
    value: "herefordshire",
  },

  {
    title: "Hertfordshire",
    value: "hertfordshire",
  },

  {
    title: "Isle of Wight",
    value: "isle_of_wight",
  },

  {
    title: "Kent",
    value: "kent",
  },

  {
    title: "Lancashire",
    value: "lancashire",
  },

  {
    title: "Leicestershire",
    value: "leicestershire",
  },

  {
    title: "Lincolnshire",
    value: "lincolnshire",
  },

  {
    title: "Merseyside",
    value: "merseyside",
  },

  {
    title: "Norfolk",
    value: "norfolk",
  },

  {
    title: "North Yorkshire",
    value: "north_yorkshire",
  },

  {
    title: "Northamptonshire",
    value: "northamptonshire",
  },

  {
    title: "Northumberland",
    value: "northumberland",
  },

  {
    title: "Nottinghamshire",
    value: "nottinghamshire",
  },

  {
    title: "Oxfordshire",
    value: "oxfordshire",
  },

  {
    title: "Rutland",
    value: "rutland",
  },

  {
    title: "Shropshire",
    value: "shropshire",
  },

  {
    title: "Somerset",
    value: "somerset",
  },

  {
    title: "South Yorkshire",
    value: "south_yorkshire",
  },

  {
    title: "Staffordshire",
    value: "staffordshire",
  },

  {
    title: "Suffolk",
    value: "suffolk",
  },

  {
    title: "Surrey",
    value: "surrey",
  },

  {
    title: "Tyne and Wear",
    value: "tyne_and_wear",
  },

  {
    title: "Warwickshire",
    value: "warwickshire",
  },

  {
    title: "West Midlands",
    value: "west_midlands",
  },

  {
    title: "West Sussex",
    value: "west_sussex",
  },

  {
    title: "West Yorkshire",
    value: "west_yorkshire",
  },

  {
    title: "Wiltshire",
    value: "wiltshire",
  },

  {
    title: "Worcestershire",
    value: "worcestershire",
  },
  {
    title: "Isle of Anglesey",
    value: "isle_of_anglesey",
  },
  {
    title: "Gwynedd",
    value: "gwynedd",
  },
  {
    title: "Conwy",
    value: "conwy",
  },
  {
    title: "Denbighshire",
    value: "denbighshire",
  },
  {
    title: "Flintshire",
    value: "flintshire",
  },
  {
    title: "Wrexham",
    value: "wrexham",
  },
  {
    title: "Ceredigion",
    value: "ceredigion",
  },
  {
    title: "Powys",
    value: "powys",
  },
  {
    title: "Pembrokeshire",
    value: "pembrokeshire",
  },
  {
    title: "Carmarthenshire",
    value: "carmarthenshire",
  },
  {
    title: "Swansea",
    value: "swansea",
  },
  {
    title: "Neath Port Talbot",
    value: "neath_port_talbot",
  },
  {
    title: "Bridgend",
    value: "bridgend",
  },
  {
    title: "Vale of Glamorgan",
    value: "vale_of_glamorgan",
  },
  {
    title: "Cardiff",
    value: "cardiff",
  },
  {
    title: "Rhondda Cynon Taf",
    value: "rhondda_cynon_taf",
  },
  {
    title: "Merthyr Tydfil",
    value: "merthyr_tydfil",
  },
  {
    title: "Caerphilly",
    value: "caerphilly",
  },
  {
    title: "Blaenau Gwent",
    value: "blaenau_gwent",
  },
  {
    title: "Torfaen",
    value: "torfaen",
  },
  {
    title: "Monmouthshire",
    value: "monmouthshire",
  },
  {
    title: "Newport",
    value: "newport",
  },
];

const LEAD_STAGE = [
  { title: "Pending Appointment", value: "pending", colorCode: "#C8E6C9" },
  { title: "Not Interested", value: "not_interested", colorCode: "#FFCDD2" },
  { title: "Follow Up", value: "follow_up", colorCode: "#FFF9C4" },
  { title: "Sale", value: "sale", colorCode: "#BBDEFB" },
  { title: "Transacting", value: "transacting", colorCode: "#1976D2" },
];

const endPoints = {
  // Dashboard

  getAgentDashboard: "dashboard/agent",
  getAdminDashboard: "dashboard/admin",
  getDashboardContract: "dashboard/contract",

  // Agents
  registerAgent: "user/register",
  loginAgent: "user/login",
  refreshToken: "auth/refresh-token",
  logout: "auth/logout",
  getAllAgents: "user/getAll",
  updateAgent: "user/update",
  deleteAgent: "user/delete",
  agentMarkDaysOff: "user/mark-off-days",
  getAgentOffDays: "user/off-days",
  agentRemoveOffDays: "user/remove-off-days",
  agentMarkDaysOffForAll: "user/mark-off-days-all",
  agentReport: "user/report",

  // Admin
  getAllAdmin: "admin/getAll",

  getAdminAgentDetails: "user/detail",

  // Contract
  createContract: "contract/create",
  updateContract: "contract/update",
  sendContractPdf: "contract/sendPdf",
  getAllContractById: "contract/getAllById",
  getAllContract: "contract/getAll",
  getTodaysContract: "contract/getHome",
  getContractDetail: "contract/getDetail",
  deleteContract: "contract/delete",
  sendContractSummary: "contract/send-summary",
  updateContractStatuses: "contract/update-status",
  getfollowUpDates: "contract/follow",
  getAllMeetingDetails: "lead-proposal/get-all-meeting-details",
  generateDuplicateContract: "contract/duplicate/generate",
  exportContract: "contract/export",
  getFutureContract: "contract/future",
  updateContractAgent: "contract/update-agent",

  // Web Users
  getAllWebUsers: "web-users/getAll",

  // Lead Proposal
  createLeadProposal: "lead-proposal/create",
  getAllLeadProposalByAgendId: "lead-proposal/get-all",
  updateLeadProposal: "lead-proposal/update",
  updateLeadAndResendProposal: "lead-proposal/update-resend",
  contractEndDateCount: "contract-end-date-count",
  exportMeetingLeads: "lead-proposal/export-meeting",

  // Broad band

  createBroadBand: "broadband/create",
  updateBroadBand: "broadband/update",
  getAllBroadbandByType: "broadband/get-all",
  getAdditionalServiceByType: "broadband/services/get-all",
  getBroadbandForWeb: "broadband/get",

  // Equipment

  createEquipment: "equipment/create",
  updateEquipment: "equipment/update",
  getEquipment: "equipment/get",

  // Bank Validation

  customerBankValidation: "customer/bank-validation",

  // Phone validation

  customerPhoneValidation: "customer/phone-validation",

  // Notification

  getUnreadNotificationCount: "notification/un-read-count",
  getNotifications: "notification/get",

  // Product
  product: "product",

  // Discount
  discount: "discount",
  getProspectDiscount: "discount/prospect",

  // Service Agrement
  getAllServiceAgrement: "agreement",
  getServiceAgrementById: "agreement",
  updateServiceAgrement: "agreement",
  deleteServiceAgrement: "agreement",
  resendServiceAgrement: "agreement/:id/resend",

  // Legal content
  updateLegalContent: "legal-content/:id",
  getLegalContentByType: "legal-content/:type",
};

export {
  constants,
  emailRegex,
  requestType,
  endPoints,
  CONTRACT_TERMS,
  CONTRACT_LENGTHS,
  getDefaultContractLengths,
  POSITION,
  COUNTIES,
  LEAD_STAGE,
};
